import React, { useEffect, useState } from 'react';
import ReportHeaderComponent from '../components/reportHeaderComponent';
import Table from '../../../../component/table/Table';
import PageLoader from '../../../../component/PageLoader';
import checkScheduledIcon from '../../../../assets/image/check-schedule-icon.svg';
import favColorIcon from '../../../../assets/image/fav_icon_color.svg';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import ReportScheduledDrawer from '../components/reportScheduledDrawer';
import {
	exportExcelReport,
	getFavReport,
	removeFavouriteReport,
} from '../../../../services/reports';
import { formatAMPMDate } from '../../../../utils/constant';
import { toast } from 'react-toastify';
import ScheduleReportModal from '../components/scheduleReportModal';
import { useNavigate } from 'react-router-dom';

export default function FavouriteReports({ activeTab, setIsCollapse, isCollapse }) {
	const [sortDirection, setSortDirection] = useState({});
	const [reportName, setReportName] = useState(null);
	const [scheduledId, setScheduledId] = useState(null);
	const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
	const [loader, setLoader] = useState(false);
	const [isExportExcelLoader, setIsExportExcelLoader] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const [params, setParams] = useState({
		pageSize: 10000,
		page: 1,
		orderBy: '',
		sortBy: '',
	});
	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};

	const [favouriteReportList, setFavouriteReportList] = useState([]);

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const onRowClick = (id) => {
		const data = favouriteReportList.find((item) => item.id === id);
		navigate(`/user/${suburl}/reports/${data.report_name.replaceAll(' ', '-').toLowerCase()}`);
	};

	const handleExportExcel = async () => {
		try {
			setIsExportExcelLoader(true);
			let data = {};
			const res = await exportExcelReport('favorites', data);
			if (res.success) {
				const a = document.createElement('a');
				a.href = res.data.signed_url;
				a.download = `favorites_report_table.xlsx`;
				document.body.appendChild(a);
				a.click();
				a.remove();
				toast.success(res.message);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setIsExportExcelLoader(false);
		}
	};

	const favouriteReportColumns = [
		{
			field: 'REPORT NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			autoHeight: true,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'report_name', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REPORT NAME
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.report_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const data = JSON.parse(params.data.fav_report);
				return (
					<div className="d-flex align-items-center justify-content-start gap-4">
						<img
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								handleFavReport(data.report_key);
							}}
							width={20}
							height={20}
							className="cursor-pointer"
							src={favColorIcon}
							alt="scheduled-icon"
						/>
						<div className="fs-4 fw-light">{data.report_name}</div>
					</div>
				);
			},
		},
		{
			field: 'REPORT CATEGORY',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'report_category', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								REPORT CATEGORY
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.report_category]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return (
					<div className="fs-4 fw-light d-flex align-items-center">
						{params.data.report_category}
					</div>
				);
			},
		},
		{
			field: 'CREATED BY',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'created_by', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								CREATED BY
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.created_by]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return (
					<div className="fs-4 fw-light d-flex align-items-center">{params.data.created_by}</div>
				);
			},
		},
		{
			field: 'LAST VISITED',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 350,
			maxWidth: 350,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'last_visited', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								LAST VISITED
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.last_visited]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const data = JSON.parse(params.data.last_visited);
				return (
					<div className="d-flex align-items-center justify-content-between">
						<div className="fs-4 fw-light">{data.last_visited_date}</div>
						{data.check_scheduled && (
							<img
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									setScheduledId(params.data.id);
									setReportName(params.data.report_name);
									setIsOpen(true);
								}}
								className="cursor-pointer"
								width={20}
								height={20}
								src={checkScheduledIcon}
								alt="scheduled-icon"
							/>
						)}
					</div>
				);
			},
		},
	];

	const getFavReportList = async () => {
		try {
			setLoader(true);
			const { favorites } = await getFavReport(params);
			if (favorites.length > 0) {
				const data = mappedTableData(favorites);
				setFavouriteReportList(data);
			} else {
				setFavouriteReportList([]);
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.scheduled_report_id,
				report_name: ele.report_name,
				fav_report: JSON.stringify({ report_name: ele.report_name, report_key: ele.report_key }),
				report_key: ele.report_key,
				report_category: ele.report_category,
				created_at: ele.created_at,
				created_by: ele.created_by,
				last_visited: JSON.stringify({
					last_visited_date:
						ele.last_visited_at !== null && ele.last_visited_at !== ''
							? formatAMPMDate(ele.last_visited_at)
							: '',
					check_scheduled: ele.is_scheduled,
				}),
			};
		});
	}

	const handleFavReport = async (key) => {
		try {
			const res = await removeFavouriteReport(key);
			if (res.success) {
				toast.success(res.message);
				getFavReportList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {}
	};

	useEffect(() => {
		getFavReportList();
	}, [params.orderBy, params.sortBy]);

	return (
		<div>
			<div>
				<div style={{ backgroundColor: '#FFF', position: 'sticky', top: 0, zIndex: 100 }}>
					<ReportHeaderComponent
						title={'Favourite Report'}
						subtitle={false}
						setIsCollapse={setIsCollapse}
						isCollapse={isCollapse}
						activeTab={activeTab}
						fromDate={''}
						toDate={''}
						buttons={[
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Export to Excel',
								disabled: isExportExcelLoader,
								loader: isExportExcelLoader,
								handler: () => handleExportExcel(),
							},
						]}
					/>
				</div>
				<div className="report-main-tabs-table">
					{loader ? (
						<PageLoader />
					) : (
						<div className="productTable-body">
							<Table
								row={favouriteReportList}
								coloum={favouriteReportColumns}
								className="productTable"
								onRowClick={onRowClick}
								style={{ height: 'calc(100vh - 143px)' }}
							/>
						</div>
					)}
				</div>
			</div>
			{isScheduleModalOpen && (
				<ScheduleReportModal
					isScheduleModelOpen={isScheduleModalOpen}
					setIsScheduleModelOpen={setIsScheduleModalOpen}
					activeTab={reportName}
					getList={() => {
						getFavReportList();
						setScheduledId(null);
					}}
					id={scheduledId}
				/>
			)}

			<ReportScheduledDrawer
				id={scheduledId}
				isOpen={isOpen}
				setIsScheduleModelOpen={setIsScheduleModalOpen}
				getList={() => getFavReportList()}
				onClose={() => setIsOpen(false)}
			/>
		</div>
	);
}
